import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatRadioModule } from '@angular/material/radio'
import { RouterModule, Router } from '@angular/router'
import { TranslationService } from '../../../services/translation.service'
import { IngredientTemplateListComponent } from './ingredient-template-list/ingredient-template-list.component'

@Component({
  selector: 'app-ingredient-csv-templates',
  imports: [
    RouterModule,
    MatExpansionModule,
    MatRadioModule,
    IngredientTemplateListComponent,
  ],
  templateUrl: './ingredient-csv-templates.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ingredient-csv-templates.component.scss',
})
export class IngredientCsvTemplatesComponent {
  translationService = inject(TranslationService)
  router = inject(Router)

  goToCreate() {
    this.router.navigate(['settings', 'ingredient-csv-templates'])
  }
}
